import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
import LogInPhoto from '../../Account/log_in_photo/index';
import Register from '../../Account/Register/index';
import RegisterPhoto from '../../Account/RegisterPhoto/index';
import WrappedRoutes from './WrappedRoutes';
import Home from './Home';
import AssetsDashboard from '../../Dashboards/Assets/index';
import Layout from '../../Layout/index';

class Router extends Component {
  render() {
    const { token } = this.props;
    return (
      <MainWrapper>
        <main>
          <Switch>
            <Route path="/404" component={NotFound404} />
            <Route path="/lock_screen" component={LockScreen} />
            <Route path="/log_in" component={LogIn} />
            <Route path="/log_in_photo" component={LogInPhoto} />
            <Route path="/register" component={Register} />
            <Route path="/register_photo" component={RegisterPhoto} />
            {token ? <Route path="/" component={WrappedRoutes} />
            : <Route  path="/" name="Login Page" component={LogIn} />}
          </Switch>
        </main>
      </MainWrapper>
    );
  }
}

function mapStateToProps({ token }) {
  return {
    token
  };
}

export default connect(mapStateToProps, null)(Router);

